export const QuestionnaireTemplate = "questionnaire_template";
export const CategoryTemplate = "question_category_template";
export const GroupTemplate = "question_group_template";
export const QuestionTemplate = "question_template";
export const AnswerTemplate = "answer_template";
export const ActionTemplate = "questionnaire_action_template"; // Removed metadata from actions, but some files still use this, TODO need to remove them also


